class TrLazyVideo extends HTMLElement {
	selectors = {
		media: '[data-tr-js-lazy-video-media]'
	};

	attributes = {};

	stateClasses = {};

	connectedCallback() {
		this.mediaElement = this.querySelector(this.selectors.media);
		this.observer = null;

		this.init();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		if (!this.mediaElement) return;

		if (!('IntersectionObserver' in window)) {
			this.playMedia();
			return;
		}

		this.observer = new IntersectionObserver(this.onIntersection, {
			rootMargin: '300px 0px'
		});

		this.observer.observe(this);
	}

	onIntersection = entries => {
		const isVisible = entries.some(entry => entry.isIntersecting);

		if (!isVisible) return;

		this.playMedia();
		this.destroy();
	};

	playMedia() {
		this.mediaElement.play().catch(() => {});
	}

	destroy() {
		if (!this.observer) return;

		this.observer.disconnect();
		this.observer = null;
	}
}

if (!customElements.get('tr-lazy-video')) {
	customElements.define('tr-lazy-video', TrLazyVideo);
}
